/* eslint-disable no-debugger */
import { Fragment } from "react";

import useAccountManagementCanvas from "./UseAccountManagementCanvas";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";

import Constants from "@usas/ui-web/utils/Constants";

const AccountManagementCanvas = () => {
  const {
    isLoading,
    canvasObj,
  } = useAccountManagementCanvas();

  return (
    <Fragment>
      <div className="usas-account-canvas-container">
        <div className="usas-account-canvas-header">
          <Headings.H3>Canvas Account Details</Headings.H3>
        </div>
        <div className="usas-account-canvas-content">
          <div className="usas-account-canvas-row">
            <span className="usas-account-canvas-label">Identity Provider ID: </span>
            <span className="usas-account-canvas-value">
              {canvasObj.identityProviderId ?? <em>No canvas data on file</em>}
            </span>
          </div>
          <div className="usas-account-canvas-row">
            <span className="usas-account-canvas-label">LMS User ID: </span>
            <span className="usas-account-canvas-value">
              {canvasObj.lmsUserId ?? <em>No LMS user data on file</em>}
            </span>
          </div>
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading}
      />
    </Fragment>
  );
};

export default AccountManagementCanvas;